import { ServicePermissions } from "@/enums/ServicePermissions";

const extractServiceName = (input: string) => input.split('|')[0];

export function mapPermissions(permissions: string[]) : ServicePermissions[] {
  return permissions
    .map(input => extractServiceName(input))
    .filter((service): service is ServicePermissions => 
      Object.values(ServicePermissions).includes(service as ServicePermissions))
    .sort((a, b) => a.localeCompare(b));
}